import { PostSupplierEnquiryMessageBody } from "@givenwell/marketplace-api";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { api } from "./utils";

export const supplierQueryOptions = (supplierId: string) =>
  queryOptions({
    queryKey: ["supplier", supplierId],
    queryFn: async () => {
      return await api.suppliers.getSupplierForMarketplace({ supplierId });
    },
  });

export const supplierListingsQueryOptions = (supplierId: string, marketId: string | null) =>
  queryOptions({
    queryKey: ["supplier", supplierId, "listings", marketId],
    queryFn: async () => {
      return await api.suppliers.getListingsFromSupplier({ supplierId, market: marketId as any });
    },
  });

export function usePostSupplierEnquiryMutation(supplierId: string) {
  return useMutation({
    mutationFn: async (requestBody: PostSupplierEnquiryMessageBody) => {
      return await api.suppliers.postSupplierEnquiry({ supplierId, requestBody });
    },
  });
}

export function supplierLegalQueryOptions(supplierId: string) {
  return queryOptions({
    queryKey: ["supplier", supplierId, "legal"],
    queryFn: async () => {
      return await api.suppliers.getLegalForMember({ supplierId });
    },
  });
}
